import { render } from "./GameShow.vue?vue&type=template&id=4b6c9fff&scoped=true"
import script from "./GameShow.vue?vue&type=script&lang=js"
export * from "./GameShow.vue?vue&type=script&lang=js"

import "./GameShow.vue?vue&type=style&index=0&id=4b6c9fff&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4b6c9fff"

export default script